import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import registerServiceWorker from './registerServiceWorker'
import './polyfill'
import 'normalize.css'
import 'sanitize.css'
import './index.css'

export const disableReactDevTools = (): void => {
  const noop = (): void => undefined;
  const DEV_TOOLS = (window as any).__REACT_DEVTOOLS_GLOBAL_HOOK__;

  if (typeof DEV_TOOLS === 'object') {
    for (const [key, value] of Object.entries(DEV_TOOLS)) {
      DEV_TOOLS[key] = typeof value === 'function' ? noop : null;
    }
  }
}

// disableReactDevTools()

ReactDOM.render(<App />, document.getElementById('root'))

// registerServiceWorker()

// Hot reload
const hotModule = (module as any).hot // tslint:disable-line:no-any
if (hotModule) {
  hotModule.accept()
}

// Sentry
if (process.env.NODE_ENV === 'production') {
  registerServiceWorker()
  /*require('raven-js')
    .config('https://66b3256fb40e4783ad2458f3a13226aa@sentry.io/219864')
    .install()*/
}
// console.clear()



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/index.tsx